import axios from 'axios';

const state = {
    items: [],
    shopper_session_id: '',
    cartChanged: false,
    totalItems: 0
};

const getters = {
    items(state) {
        return state.items;
    },
    shopperSessionId(state) {
        return state.shopper_session_id
    }
};

const mutations = {
    pushItem(state, item) {
        state.items.push(item);
    },
    removeItem(state, item) {
        state.items.splice(state.items.findIndex(i => i.product.id === item.product.id), 1);
    },
    setItems(state, items) {
        state.items = items;
    },
    setCartChange(state, status) {
        state.cartChanged = status;
    },
    setShopperSessionId(state, id)
    {
        state.shopper_session_id = id
    }
};

const actions = {
    pushItem({commit, state}, payload) {
        let formData = new FormData;

        Object.keys(payload).forEach(k => {
            formData.append(k, payload[k]);
        });

        return axios.post('/cart', formData).then(res => {
            commit('setCartChange', true);
            window.toastr.info(res.data.text);
        }).catch(err => {
            console.log(err);
            window.toastr.error(Object.get(err, 'response.data.text', 'Error adding item to cart'));
            state.cartChanged = false;
        });
    },
    removeItem({commit, state}, payload) {
        return axios.delete(payload.delete_url).then(response => {
            window.toastr.info(response.data.text);
            commit('setCartChange', true);
        }).catch(error => {
            console.log(error);
            window.toastr.error("There was an issue removing the item from the cart")
        });
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};